module.exports = __webpack_public_path__ + "static/media/ic_search_gray.cad46969.svg";